import {
	useGetOnboardingState,
	useSetOnboardingState,
	deserializeState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState.ts';
import { ONBOARDING_EXPERIENCES } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';

export const useGetTemplateOnboardingViewedTime = () => {
	const {
		data: onboardingStateData,
		loading: isLoading,
		error,
	} = useGetOnboardingState([ONBOARDING_EXPERIENCES.TEMPLATE_ONBOARDING_VIEWED_TIME]);
	if (error) {
		return { isLoading: false, templateOnboardingViewedTime: 0 };
	}

	if (isLoading) {
		return {
			isLoading,
			templateOnboardingViewedTime: 0,
		};
	}
	const { templateOnboardingViewedTime } = deserializeState(onboardingStateData);
	const templateOnboardingViewedTimeNumber = +templateOnboardingViewedTime;
	return {
		isLoading: false,
		templateOnboardingViewedTime: Number.isNaN(templateOnboardingViewedTimeNumber)
			? 0
			: templateOnboardingViewedTimeNumber,
	};
};

export const useSetTemplateOnboardingViewedTime = () => {
	const { setOnboardingState } = useSetOnboardingState();
	return {
		setTemplateOnboardingViewedNow: () => {
			const now = Date.now().toString();
			setOnboardingState({
				key: ONBOARDING_EXPERIENCES.TEMPLATE_ONBOARDING_VIEWED_TIME,
				value: now,
			});
		},
	};
};
